import * as React from 'react';
import { addClass } from '../../../utils/css.js';
import { Size } from '../../../constants.js';
import { RequiredAsterisk } from '../../RequiredAsterisk/RequiredAsterisk.js';
import { FormInfo } from '../Info/FormInfo.js';
import { FormError } from '../Error/FormError.js';
import { Label } from '../../Label/Label.js';
import { useId } from '../../../utils/hooks/useId.js';
import { decorateLabelProps, decorateRequiredAsteriskProps, reduceComponentProps, bem } from './formItemHelpers.js';
import { useWarnOnDeprecatedProps } from '../../../utils/hooks/useWarnOnDeprecatedProps.js';
import './FormItem.scss.js';

function _FormItem(props, ref) {
  const {
    component: Component = null,
    labelWidth = Size.M,
    suppressErrors = false,
    requiredAsteriskProps = {},
    labelProps = {},
    errors,
    htmlId,
    dataTa = "vai-form-item",
    label,
    info,
    className,
    disabled,
    required,
    children
  } = props;
  const id = useId(htmlId, ["form item"]);
  const errorsToDisplay = !suppressErrors && errors && errors !== true ? errors : null;
  useWarnOnDeprecatedProps("3.0.0", "FormItem", {
    component: `Pass the input as a child of FormItem:
            <Form.Item
                required
                label="ID"
            >
                <InputField value={value} onChange={onChange} />
            </Form.Item>
        `,
    suppressErrors: `Use the errors prop to hide or display errors`
  }, arguments);
  const decoratedLabelProps = React.useMemo(() => decorateLabelProps({ labelProps, labelWidth, disabled }), [labelProps, labelWidth, disabled]);
  const decoratedRequiredAsteriskProps = React.useMemo(() => decorateRequiredAsteriskProps({ required, requiredAsteriskProps }), [required, requiredAsteriskProps]);
  const reducedComponentProps = React.useMemo(() => reduceComponentProps(props), [props]);
  return /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    "data-ta": dataTa,
    className: addClass(bem.block(), className),
    ref
  }, /* @__PURE__ */ React.createElement(Label, {
    id: id.copyWith(["label"]).toString(),
    children: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RequiredAsterisk, {
      ...decoratedRequiredAsteriskProps
    }), label),
    ...decoratedLabelProps
  }), /* @__PURE__ */ React.createElement("div", {
    id: id.copyWith(["value"]).toString(),
    className: bem.element("value")()
  }, Component !== null ? /* @__PURE__ */ React.createElement(Component, {
    key: "form-item-component",
    ...reducedComponentProps
  }) : children, info && /* @__PURE__ */ React.createElement(FormInfo, null, info), errorsToDisplay && /* @__PURE__ */ React.createElement(FormError, null, errorsToDisplay)));
}
const FormItem = React.forwardRef(_FormItem);

export { FormItem };
